import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service3 = () => {
    const navigate = useNavigate(); // Initialize navigate

    // Function to handle navigation
    const handleNavigate = () => {
        navigate('/galleries'); // Navigate to the gallery page
    };

    return (

    <div className="about-events-container">
                    {/* First table for images and content */}

                    <div className="about-events-images">
                                     <img src="/images/room1.webp" />
                                     <img src="/images/room2.webp"/>
                                     <img src="/images/room3.webp"/>
                                     <img src="/images/room4.webp" />
                                   </div>

                        <div className="about-events-content">
                                                    <h2 className="about-header-service">Cocoloco Accommodation</h2>
                                                    <p className="about-events-description">

                            <p>Cocoloco offers spacious accommodation in a beautiful bungalow that spreads across a large area. The bungalow features 7 well-appointed rooms, each equipped with modern bathroom facilities and air conditioning for your comfort. The rooms are designed with cozy bedding to ensure a restful stay.</p>
                             <p>It’s the ideal retreat to unwind, surrounded by the serene beauty of Cocoloco Garden. Come and enjoy a calming, rejuvenating stay, where you can truly relax and recharge.</p>
</p>
                            <button className="service-button" onClick={handleNavigate}>
                                Click Here For See More Gallery ..
                            </button>
                       </div>

                                                                               </div>
    );
};

export default Service3;
